import { FunctionComponent } from 'react';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import { INavigationHeaderCreateButtonProps } from './NavigationHeaderCreateButton.interface';

export const NavigationHeaderCreateButton: FunctionComponent<INavigationHeaderCreateButtonProps> = ({ label, onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      size={'small'}
      color={'primary'}
      aria-label={label}
      sx={{ p: 0, marginLeft: 'auto' }}
    >
      <AddIcon />
    </IconButton>
  );
};
